export const menuData = [
  {
    id: 1,
    label: "Account",
    path: "/",
  },
  // {
  //   id: 2,
  //   label: "Subscription",
  //   path: "/subscription",
  //   subItems: [
  //     {
  //       id: 3,
  //       label: "Plans",
  //       path: "/plans",
  //     },
  //     {
  //       id: 4,
  //       label: "Payment",
  //       path: "/payment",
  //     },
  //   ],
  // },
  // {
  //     id: 5,
  //     label: "Organization",
  //     path: "/organitzation",
  // },
  // {
  //     id: 6,
  //     label: "Patiens",
  //     path: "/patiens",
  // },
];
